import { useCallback, useEffect, useState } from 'react'
import { userAPI } from '../services/api'

/**
 * The signed-in user's saved layouts for one report, stored on their account so
 * they follow them across browsers. Writes are optimistic and roll back on
 * failure, so a slow save never makes the menu feel stuck.
 */
export function useSavedViews(report) {
  const [views, setViews] = useState([])
  const [status, setStatus] = useState({ loading: true, error: null })

  useEffect(() => {
    let active = true
    userAPI.getReportViews(report)
      .then(response => { if (active) { setViews(response.data.data.views || []); setStatus({ loading: false, error: null }) } })
      .catch(() => { if (active) setStatus({ loading: false, error: 'Saved views could not be loaded.' }) })
    return () => { active = false }
  }, [report])

  const save = useCallback(async next => {
    const previous = views
    setViews(next)
    try {
      const response = await userAPI.saveReportViews(report, next)
      setViews(response.data.data.views)
      setStatus({ loading: false, error: null })
      return true
    } catch (error) {
      setViews(previous)
      setStatus({ loading: false, error: error.response?.data?.error?.message || 'The view could not be saved.' })
      return false
    }
  }, [report, views])

  return { views, save, ...status }
}
